import { noop } from "angular";
import { IModalService } from "angular-ui-bootstrap";
import { Session } from "@webapp/sessions/models/sessions.model";
import { DeletePlanningSessionCtrl } from "../controllers/delete-planning-session.ctrl";
import { DemoSessionCtrl } from "../controllers/demo-session";

export class DeleteSessionConfirmationService {
  public static $inject = ["$uibModal"];

  constructor(private $uibModal: IModalService) {}

  public confirmDeletePlanningSession(planningSession: Session, onConfirmDelete: () => void): void {
    this.$uibModal
      .open({
        template: require("../views/confirm-delete.html"),
        windowClass: "medium",
        controller: DeletePlanningSessionCtrl,
        resolve: {
          planningSession: () => planningSession,
        },
      })
      .result.then(() => onConfirmDelete(), noop);
  }

  public confirmDeleteDemoSession(): void {
    this.$uibModal.open({
      template: require("../views/confirm-delete-demo.html"),
      windowClass: "medium",
      controller: DemoSessionCtrl,
    });
  }
}
